import React from 'react'
import { Radio, Table, Modal, Select, InputNumber, Input, Switch, Row, Col, Icon } from 'antd'
import {Button as AntDButton} from 'antd'
import { Tooltip, Fab } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import styles from '../../../styles'
import withStyles from '@material-ui/core/styles/withStyles'
import {uuid} from '../../../functions'

import * as _ from 'lodash'

const { Column } = Table
const Option = Select.Option

export class PredictionColumnsEditor extends React.Component {

    constructor(props) {
        super(props)
        // values for modal editing
        this.state = {
            editModalVisible: false,
            // the column currently editing
            editModalColumn: undefined,
        }
    }

    handleAdd=() =>{
        let newMapping =  this.props.mapping
        let columns = _.toArray(this.props.mapping.columns)
        columns.push({name:'new', type:'STRING', key : uuid()})
        newMapping.columns  =  columns
        this.onChange(newMapping)
        
    }
    handleRemove=(index) =>{
        if (this.props.canDelete) {
            let newMapping =  this.props.mapping
            let columns = _.toArray(this.props.mapping.columns)
            columns.splice(index,1 )
            newMapping.columns = columns
            this.onChange(newMapping)
        }
    }
    openDialog = (index) => {
        const column =  this.props.mapping.columns[index]
        const editModalColumnBoundaries = []
        if (column.boundaries) {
            _.forEach(column.boundaries, (item, index) => {
                editModalColumnBoundaries.push({ key: index, boundary: item })
            })
        }

        let editModalStringValues = []
        if (column.values) {
            _.forEach(column.values, (item, index) => {
                editModalStringValues.push({ key: index, stringValue: item })

            })
        }
        const editModalStringCount = column.valuesCount

        this.setState({
            editModalVisible: true,
            editIndex : index,
            editModalColumn: column,
            editModalColumnBoundaries: editModalColumnBoundaries,
            editModalColumnStringValues: editModalStringValues,
            editModalColumnStringCount: editModalStringCount
        })
    }

    editModalOk = () => {
        // this is where it gets difficult
        this.setState({
            editModalVisible: false,
            editModalColumn: undefined,
        })
        let newMapping = { ...this.props.mapping }// { ...this.props.value }
        let updatedColumn = { ...this.state.editModalColumn }
        // set the updated column
        if (updatedColumn.type === 'STRING') {
            // check if we need to update the string details
            updatedColumn.boundaries = undefined
            if (this.state.editModalColumnStringCountVisible) {
                //we need to set the string count
                updatedColumn.valuesCount = this.state.editModalColumnStringCount
                updatedColumn.values = undefined
            }
            else {
                updatedColumn.valuesCount = undefined
                updatedColumn.values = _.map(this.state.editModalColumnStringValues, 'stringValue')
            }
        }
        else {
            updatedColumn.valuesCount = undefined
            updatedColumn.values = undefined
            updatedColumn.boundaries = _.map(this.state.editModalColumnBoundaries, 'boundary')
        }
        newMapping.columns[this.state.editIndex] = updatedColumn
        // const indexOfInputFields = _.findIndex(newMapping.inputFields, {'name' :updatedColumn.name})
        // newMapping.inputFields[indexOfInputFields] = updatedColumn
        this.onChange(newMapping)
    }

    onChange = (e) => {
        // update the form if this component is wrapped inside a form item (as it is in PredictionConfigEditor)
        if (this.props.onChange) {
            this.props.onChange(e)
        }
    }

    editModalCancel = () => {
        this.setState({
            editModalVisible: false,
            editModalColumn: undefined
        })
    }

    handleAddBoundary = () => {

        const boundaries = this.state.editModalColumnBoundaries || []

        let maxValue = _.maxBy(boundaries, 'boundary')
        maxValue = maxValue ? maxValue.boundary + 1 : 0
        const newBoundary = {
            key: boundaries.length || 0,
            boundary: maxValue || 0
        }
        this.setState({
            editModalColumnBoundaries: [...boundaries, newBoundary]
        })
    }


    handleBoundaryChange = (value, index) => {
        let editModalColumnBoundaries = this.state.editModalColumnBoundaries
        editModalColumnBoundaries[index].boundary = value
        this.setState({
            editModalColumnBoundaries: editModalColumnBoundaries
        })
    }

    handleDeleteBoundary = (e, index) => {
        let editModalColumnBoundaries = this.state.editModalColumnBoundaries
        _.remove(editModalColumnBoundaries,
            boundary => { return boundary.key === index }
        );
        this.setState({
            editModalColumnBoundaries: editModalColumnBoundaries
        })
    }
    handleAddStringValue = () => {
        const stringValues = this.state.editModalColumnStringValues || []
        const newStringValue = {
            key: stringValues.length || 0,
            stringValue: ''
        }
        this.setState({
            editModalColumnStringValues: [...stringValues, newStringValue]
        })
    }

    handleStringValueChange = (value, index, another) => {
        let editModalColumnStringValues = this.state.editModalColumnStringValues
        editModalColumnStringValues[index].stringValue = value.target.value
        this.setState({
            editModalColumnStringValues: editModalColumnStringValues
        })
    }

    handleDeleteStringValue = (e, index) => {
        let editModalColumnStringValues = this.state.editModalColumnStringValues
        _.remove(editModalColumnStringValues,
            stringValue => { return stringValue.key === index }
        );
        this.setState({
            editModalColumnStringValues: editModalColumnStringValues
        })
    }


    handleStringSwitchChange = (e) => {
        this.setState({
            editModalColumnStringCountVisible: e
        })
    }

    handleStringCountChange = (e) => {
        this.setState({
            editModalColumnStringCount: e
        })
    }

    handleTypeChange = (value) => {
        this.setState({
            editModalColumn: { ...this.state.editModalColumn, type: value }
        })
    }

    handleNameChange = (e) => {
        this.setState({
            editModalColumn: { ...this.state.editModalColumn, name: e.target.value }
        })
    }

    handleLabelColumnSelected = (index) => {
        let newMapping = { ...this.props.mapping }
        if (!newMapping) {
            return
        }

        // undo any columns that were set before
        _.forEach(newMapping.columns, col => {
            col.isLabelColumn = false
        })


        newMapping.columns[index].isLabelColumn = true
        // const indexOfInputFields = _.findIndex(newMapping.inputFields, {'name' :updatedColumn.name})
        // newMapping.inputFields[indexOfInputFields] = updatedColumn
        const indexOfColSel = _.indexOf(newMapping.selectedRowKeys, index)
        if (indexOfColSel >= 0) {
            newMapping.selectedRowKeys.splice(indexOfColSel, 1)
        }
        // const indexOfColSel = _.indexOf(newMapping.selectedRowKeys, key)
        // if (indexOfColSel >= 0) {
            // newMapping.selectedRowKeys.splice(indexOfColSel, 1)
        // }
        this.onChange(newMapping)

    }

    renderModal() {
        const stringValues = _.forEach(this.state.editModalColumnStringValues, (value, index) => { return { stringValue: value, key: index } })
        const boundaryValues = _.toArray(this.state.editModalColumnBoundaries, (value, index) => { return { boundary: value, key: index } })

        return (
            <div>
            {this.props.canEditName?
                <Row gutter={16}>
                    <Col span={6}>Column name:</Col>
                    <Col span={6}>
                        <Input
                            key={'name'}
                            onChange={this.handleNameChange}
                            defaultValue={this.state.editModalColumn.name}
                        >
                        </Input>
                    </Col>
                </Row>
            : undefined}

                <Row gutter={16}>
                    <Col span={6}>Column type:</Col>
                    <Col span={6}>
                        <Select
                            key={this.props.mkey}
                            onChange={this.handleTypeChange}
                            value={this.state.editModalColumn.type}
                        >
                            <Option value='STRING'> String</Option>
                            {/* <Option value='boolean'>Boolean</Option> */}
                            <Option value='INTEGER'>Integer</Option>
                            <Option value='FLOAT'>Float</Option>
                        </Select>
                    </Col>
                </Row>
                {
                    this.state.editModalColumn.type === 'STRING' ?
                        <div>
                            <Row><div/></Row>

                            <Row>
                                <Col span={6}> Use values count </Col>
                                <Col span={6}>
                                    <Switch onChange={this.handleStringSwitchChange}
                                        checked={this.state.editModalColumnStringCountVisible} />
                                </Col>
                            </Row>
                            {
                                this.state.editModalColumnStringCountVisible ?
                                    <Row>
                                        Number of possible values in columns:
                                        <InputNumber
                                            key='modalColumnStringCount'
                                            precision={0}
                                            onChange={this.handleStringCountChange}
                                            value={this.state.editModalColumnStringCount}
                                        />

                                    </Row>

                                    :
                                    <div>< br />
                                        <Row>
                                            <AntDButton
                                                onClick={this.handleAddStringValue}
                                                type="primary"
                                                style={{ marginBottom: 16 }}>
                                                Add a value
                                            </AntDButton>
                                        </Row>
                                        <Row>
                                            <Table
                                                pagination={false}
                                                dataSource={stringValues}
                                                rowKey='key'
                                            >
                                                <Column title='Values'
                                                    dataIndex='values'
                                                    key='values'
                                                    render={(text, record, index) => {
                                                        return (<Input
                                                            key={record.key}
                                                            precision={0}
                                                            onChange={(e) => this.handleStringValueChange(e, record.key)}
                                                            value={record.stringValue}
                                                        />)
                                                    }}
                                                />
                                                <Column title=''
                                                    render={(text, record) => (
                                                        <span>
                                                            <a onClick={(e) => this.handleDeleteStringValue(e, record.key)}>Delete</a>
                                                        </span>
                                                    )}
                                                />
                                            </Table>
                                        </Row>
                                    </div>
                            }
                        </div>
                        : <div>
                            <Row>< br /></Row>
                            <Row>
                                <AntDButton
                                    onClick={this.handleAddBoundary}
                                    type="primary"
                                    style={{ marginBottom: 16 }}>
                                    Add a boundary
                                </AntDButton>
                            </Row>
                            <Row>
                                <Table
                                    pagination={false}
                                    dataSource={boundaryValues}
                                    rowKey='key'
                                >
                                    <Column title='Boundary'
                                        dataIndex='boundary'
                                        key='boundary'
                                        render={(text, record, index) => {
                                            if (this.state.editModalColumn.type === 'integer') {
                                                return (<InputNumber
                                                    key={record.key}
                                                    precision={0}
                                                    onChange={(val) => this.handleBoundaryChange(val, record.key)}
                                                    value={record.boundary}
                                                />)
                                            }
                                            else {
                                                return (<InputNumber
                                                    key={record.key}
                                                    onChange={(val) => this.handleBoundaryChange(val, record.key)}
                                                    value={record.boundary}
                                                />)
                                            }
                                        }}
                                    />
                                    <Column title=''
                                        render={(text, record) => (
                                            <span>
                                                <a onClick={(e) => this.handleDeleteBoundary(e, record.key)}>Delete</a>
                                            </span>
                                        )}
                                    />
                                </Table>
                            </Row>
                        </div>
                }
            </div>

        )
    }

    render() {
        const columns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            }, {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
            }, {
                title: 'Label',
                render: (text, record, index) => {
                    return (<Radio
                        checked={record.isLabelColumn}
                        onClick={() => this.handleLabelColumnSelected(index)}
                    />)
                }
            }, {
                title: 'Details',
                render: (text, record, index) => {
                    if (record.type === 'STRING') {
                        if (record.valuesCount > 0) {
                            return ("Buckets: " + record.valuesCount)
                        }
                        else if (record.values && record.values.length > 0) {
                            return ('Values: [' + _.join(record.values, ' ,') + ']')
                        }
                    }
                    else {
                        if (record.boundaries && record.boundaries.length > 0) {
                            return ('Boundaries: [' + _.join(record.boundaries, ' ,') + ']')

                        }
                    }
                }
            }, {
                title: '',
                dataIndex: 'edit',
                key: 'edit',
                render: (item, record, index) => { return (<Icon type="edit" onClick={() => this.openDialog(index)} />) }
            }, {
                title: '',
                dataIndex: 'delete',
                key: 'delete',
                render: (item, record, index) => { return this.props.canDelete? ( <Icon type="delete" onClick={() => this.handleRemove(index)} />) : <React.Fragment/> }
            }
        ]

        if (this.props.mapping) {
            const dataSource = this.props.mapping.columns

            const rowSelection = {
                onChange: (selectedRowKeys, selectedRows) => {
                    let newMapping = this.props.mapping
                    newMapping.selectedRowKeys = selectedRowKeys
                    this.onChange(newMapping)
                },
                // const selectedColumns = this.props.mapping.selectedColumns || []
                selectedRowKeys: this.props.mapping.selectedRowKeys || [],
            }

            return (
                <div>
                    <Table
                        rowSelection={rowSelection}
                        dataSource={_.toArray(dataSource)}
                        pagination={false}
                        columns={columns}
                        rowKey = 'key'
                    />
                    {this.props.canAdd ? (
                        <Tooltip title="Add">
                        <Fab
                            color="primary"
                            className={this.props.classes.adminTableAddButton}
                            aria-label="Add"
                            onClick={this.handleAdd}>
                            <AddIcon />
                        </Fab>
                        </Tooltip>)
                    : (<React.Fragment />)}
      
                    {this.state.editModalColumn ? (
                        <Modal
                            title={"Edit column details for " + this.state.editModalColumn.name}
                            visible={this.state.editModalVisible}
                            onOk={this.editModalOk}
                            onCancel={this.editModalCancel}
                        >
                            {this.renderModal()}
                        </Modal>
                    ) : (<div />)}
                </div>
            )
        }
        else {
            return (<div>Please select a valid training datasource first</div>)
        }
    }
}
PredictionColumnsEditor =  withStyles(styles, { withTheme: true })(PredictionColumnsEditor)


// WEBPACK FOOTER //
// ./src/App/SolutionEditor/Predictions/PredictionColumnsEditor.jsx